export class LocalDeviceStorageService
  implements Bluebeam.Services.IDeviceStorageService
{
  getItem: Bluebeam.Services.IDeviceStorageService['getItem'] = async (key) => {
    if (!key?.trim()) {
      return undefined;
    }

    const stringifiedValue = localStorage.getItem(key);

    if (!stringifiedValue) {
      return undefined;
    }

    try {
      const parsed = JSON.parse(stringifiedValue);
      return Promise.resolve(parsed);
    } catch {
      return Promise.resolve(stringifiedValue);
    }
  };

  removeItem: Bluebeam.Services.IDeviceStorageService['removeItem'] = async (
    key
  ) => {
    if (!key?.trim()) {
      return;
    }

    localStorage.removeItem(key);
  };

  setItem: Bluebeam.Services.IDeviceStorageService['setItem'] = async (
    key,
    value: any
  ) => {
    if (!key?.trim()) {
      return;
    }

    const stringifiedValue = JSON.stringify(value);
    localStorage.setItem(key, stringifiedValue);
  };
}
